/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Link, InputLabel, Tab, Box } from "@mui/material";

export const AuditLogPageContainer = styled('div')({
  width: '100%',
  overflowX: 'hidden',
})

export const StyledBreadCrumbContainer = styled('div')({
  height: '20px',
  width: '100%',
  backgroundColor: '#f5f5f8',
  padding: '10px 0px 10px 20px',
  borderColor: '#e0e0e0',
  borderWidth: '0px 0px 1px 0px',
  borderStyle: 'solid',
})

export const StyledLink = styled(Link)(({ color }) => ({
  textDecoration: 'none',
  color: color,
  fontSize: '13px',
  fontWeight: '400',
}))

export const viewTypographyStyles = {
  mt: 1,
  color: "#666",
  fontSize: "0.875rem",
};

export const StyledInputLabel = styled(InputLabel)({
  fontSize: '14px',
})

export const selectBaseStyles = {
  backgroundColor: "white",
  fontSize: "0.875rem",
  "& .MuiSelect-select": { py: "6px" },
  "&.MuiOutlinedInput-root": {
    height: "2.4rem",
    "&:hover fieldset": { borderColor: "#2b4fb9" },
    "&.Mui-focused fieldset": { borderColor: "#2b4fb9" },
  },
};

export const StyledTab = styled(Tab)({
  textTransform: 'none',
  fontSize: '15px',
})

export const StatusContainer = styled(Box)(({ status }) => ({
  height: "24px",
  width: "100px",
  borderRadius: "6px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor:
    status === "success" ? "rgba(52, 199, 89, 0.1)" : "rgba(211, 47, 47, 0.1)",
  color: status === "success" ? "#2E7D32" : "#D32F2F",
}));

export const StyledImportCount = styled('span')({
  '&:hover':{
    color: '#1976d2',
    cursor: 'pointer',
  }
})

export const datePickerStyles = {
  "&:hover fieldset":{
    borderColor: '#2b4fb9 !important'
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: '#2b4fb9',
    },
  },
  ".MuiInputBase-root": {
    height: "2.4rem",
    backgroundColor: "white",
    fontSize: "14px",
  },
  "& input::placeholder": {
    color: "black",
  },
  width: { xs: "100%", sm: "140px" },
}
